export enum LeadTypes {
    AppointmentRequest = 'appointment_request',
    OccasionOffer = 'occasion_offer',
    OccasionTradeIn = 'occasion_tradein',
    OccasionTestDrive = 'occasion_test_drive',
}
